module.exports = __webpack_public_path__ + "static/media/item5.a3fc3765.png";